import { lazy } from 'react';
import { Route } from 'react-router';

import { FRONTEND_ROUTES } from '@/services/Constants';

const ProgressOverviewPage = lazy(() => import('../components/overview/ProgressOverviewPage'));
const ProgressDetailsPage = lazy(() => import('../components/details/ProgressDetailsPage'));

export const progressRoutes = () => (
	<>
		<Route path={FRONTEND_ROUTES.PROGRESS} element={<ProgressOverviewPage />} />
		<Route path={FRONTEND_ROUTES.PROGRESS_DETAILS} element={<ProgressDetailsPage />} />
	</>
);
